// extracted by mini-css-extract-plugin
export var searchHeader = "_45-0";
export var searchHeaderDark = "_45-1";